import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Check, Gift, Baby, Users } from 'lucide-react';
export function WhatsIncluded() {
  const tomosNinos = [{
    name: 'Tomo 1 — Mis primeras teclas: Conocé el piano jugando',
    value: '7.990'
  }, {
    name: 'Tomo 2 — Mis primeras melodías: Notas y canciones simples',
    value: '7.990'
  }, {
    name: 'Tomo 3 — Ritmo y diversión: Coordinación con las dos manos',
    value: '6.990'
  }, {
    name: 'Tomo 4 — ¡Ya toco canciones!: Repertorio completo para niños',
    value: '6.990'
  }];
  const tomosAdolescentes = [{
    name: 'Tomo 1 — Punto de partida: El teclado desde cero',
    value: '7.990'
  }, {
    name: 'Tomo 2 — Primeras canciones reales: Melodías que te gustan',
    value: '7.990'
  }, {
    name: 'Tomo 3 — Ritmo y técnica: Coordinación y fluidez',
    value: '6.990'
  }, {
    name: 'Tomo 4 — Nivel completo: Repertorio moderno y variado',
    value: '6.990'
  }];
  const bonos = [{
    name: 'Guía de práctica diaria (15 min/día)',
    value: '3.390'
  }, {
    name: 'Planillas de seguimiento y progreso',
    value: '2.490'
  }, {
    name: 'Ejercicios de calentamiento express',
    value: '2.180'
  }];
  const renderTomo = (tomo: {
    name: string;
    value: string;
  }, index: number) => <FadeIn key={index} delay={index * 0.06} direction="up" data-id="element-237">
      <div className="flex items-center justify-between gap-4 bg-navy-lighter p-4 rounded-xl border border-white/5" data-id="element-238">
        <div className="flex items-center gap-3" data-id="element-239">
          <div className="w-7 h-7 rounded-full bg-gold flex items-center justify-center flex-shrink-0" data-id="element-240">
            <Check className="w-4 h-4 text-navy" strokeWidth={3} data-id="element-241" />
          </div>
          <span className="text-base md:text-lg font-medium text-beige" data-id="element-242">
            {tomo.name}
          </span>
        </div>
        <span className="text-sm text-beige/40 line-through flex-shrink-0" data-id="element-243">
          AR$ {tomo.value}
        </span>
      </div>
    </FadeIn>;
  return <section className="py-20 bg-navy-light relative overflow-hidden" data-id="element-244">
      <div className="absolute top-20 right-0 w-96 h-96 bg-gold/8 rounded-full blur-3xl pointer-events-none" data-id="element-245"></div>

      <div className="container mx-auto px-4 max-w-4xl relative z-10" data-id="element-246">
        <FadeIn data-id="element-247">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-3" data-id="element-248">
            ¿Qué incluye <span className="text-gold" data-id="element-249">Piano Fácil PRO</span>?
          </h2>
          <p className="text-center text-beige/60 mb-12 text-lg" data-id="element-250">
            8 tomos completos + 3 bonos exclusivos
          </p>
        </FadeIn>

        {/* TOMOS — combined card with two blocks */}
        <FadeIn data-id="element-251">
          <div className="bg-navy border border-gold/20 rounded-3xl p-8 md:p-10 shadow-2xl mb-6" data-id="element-252">
            <div className="flex items-center gap-2 mb-2" data-id="element-253">
              <Check className="w-6 h-6 text-gold" data-id="element-254" />
              <h3 className="text-xl font-bold text-gold" data-id="element-255">
                8 Tomos del Método Completo
              </h3>
            </div>
            <p className="text-beige/60 text-sm mb-8 ml-8" data-id="element-256">
              <span className="line-through" data-id="element-257">Total AR$ 63.920</span>
              <span className="mx-2" data-id="element-258">→</span>
              <span className="text-green-400 font-bold" data-id="element-259">
                Solo por hoy a AR$ 28.990
              </span>
            </p>

            {/* Niños block */}
            <div className="mb-8" data-id="element-260">
              <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gold/10" data-id="element-261">
                <div className="w-8 h-8 rounded-lg bg-gold/15 flex items-center justify-center" data-id="element-262">
                  <Baby className="w-4 h-4 text-gold" data-id="element-263" />
                </div>
                <h4 className="text-base md:text-lg font-bold text-beige uppercase tracking-wide" data-id="element-264">
                  Para Niños
                </h4>
              </div>
              <div className="space-y-3" data-id="element-265">
                {tomosNinos.map((t, i) => renderTomo(t, i))}
              </div>
            </div>

            {/* Adolescentes block */}
            <div data-id="element-266">
              <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gold/10" data-id="element-267">
                <div className="w-8 h-8 rounded-lg bg-gold/15 flex items-center justify-center" data-id="element-268">
                  <Users className="w-4 h-4 text-gold" data-id="element-269" />
                </div>
                <h4 className="text-base md:text-lg font-bold text-beige uppercase tracking-wide" data-id="element-270">
                  Para Adolescentes
                </h4>
              </div>
              <div className="space-y-3" data-id="element-271">
                {tomosAdolescentes.map((t, i) => renderTomo(t, i))}
              </div>
            </div>
          </div>
        </FadeIn>

        {/* BONOS */}
        <FadeIn data-id="element-272">
          <div className="bg-gold/5 border-2 border-emerald-400/40 rounded-3xl p-8 md:p-10 shadow-xl mb-6" data-id="element-273">
            <div className="flex items-center gap-2 mb-6" data-id="element-274">
              <Gift className="w-6 h-6 text-gold" data-id="element-275" />
              <h3 className="text-xl font-bold text-gold" data-id="element-276">
                3 Bonos Exclusivos
              </h3>
            </div>

            <div className="space-y-3 mb-6" data-id="element-277">
              {bonos.map((bono, index) => <FadeIn key={index} delay={index * 0.06} direction="up" data-id="element-278">
                  <div className="flex items-center justify-between gap-4 bg-navy-lighter p-4 rounded-xl border border-emerald-400/20" data-id="element-279">
                    <div className="flex items-center gap-3" data-id="element-280">
                      <div className="w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center flex-shrink-0" data-id="element-281">
                        <Gift className="w-4 h-4 text-white" strokeWidth={2.5} data-id="element-282" />
                      </div>
                      <span className="text-base md:text-lg font-medium text-beige" data-id="element-283">
                        {bono.name}
                      </span>
                    </div>
                    <span className="text-sm text-beige/40 line-through flex-shrink-0" data-id="element-284">
                      AR$ {bono.value}
                    </span>
                  </div>
                </FadeIn>)}
            </div>

            <div className="bg-emerald-500/15 border border-emerald-400/40 rounded-xl p-3 text-center" data-id="element-285">
              <span className="text-emerald-300 font-bold text-lg" data-id="element-286">
                🎁 GRATIS POR HOY
              </span>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}